import React, { useEffect, useState } from 'react'
import ReactQuill from 'react-quill';
import useLocalStorageState from 'use-local-storage-state';
import { DeleteRequest, GetRequest, PostRequest, PutRequest } from '../../../../../Utils/hooks/ApiHandler';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FaStickyNote } from 'react-icons/fa';
import { Dropdown } from 'react-bootstrap';
import { formatDateInAlphabeticalMonth, formatTime } from '../../../../../Utils/helpers/commonhelper';
import nodata from "../../../../../Utils/assets/img/leads_no_data_found_removebg.png"
import { UnauthViewModal } from '../../../../../CommonComponents/UnauthViewModal';
import DeleteModal from '../../../../DeleteModal';
import { useGetEssentials } from '../../../../../Utils/hooks/useGetEssentials';

function forceInline(html) {
    const blockTags = ["div", "p", "h1", "h2", "h3", "h4", "h5", "h6"];

    let processed = html;
    blockTags.forEach((tag) => {
        const regex = new RegExp(`<${tag}`, "gi");
        processed = processed.replace(regex, `<${tag} style="display:inline"`);
    });

    return processed;
}

export const CompanyNotes = ({ companyId }) => {

    // Session storage and authentication setup
    const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()
    // rbac permission object
    const [PERMISSION] = useLocalStorageState('permission')

    // company notes grant
    const companyGrants = PERMISSION?.company;
    const companyNoteGrant = companyGrants?.feature.notes;

    const [loading, setLoading] = useState(false)
    const [notes, setNotes] = useState([]);
    const [isNotesOpen, setIsNotesOpen] = useState(true);
    const [notesContent, setNotesContent] = useState("");
    const [editingNoteId, setEditingNoteId] = useState(null);
    const [isNotesLoading, setIsNotesLoading] = useState(false);
    const [notesError, setNotesError] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [noteToDelete, setNoteToDelete] = useState(null);
    const [expandedNoteId, setExpandedNoteId] = useState(null);

    const fetchNotes = async () => {
        setIsNotesLoading(true);
        setNotesError(null);

        try {
            const response = await GetRequest(
                `company/fetchNotes/${companyId}/${customerId}/${loginUserId}`,
                { headers },
                extras
            );

            if (response.data) {
                setNotes(response.data);
            } else {
                setNotesError("Failed to load notes");
            }
        } catch (error) {
            setNotesError(error.message || "Error loading notes");
        } finally {
            setIsNotesLoading(false);
        }
    };

    useEffect(() => {
        if (companyId) {
            fetchNotes();
        }
    }, [companyId]);


    // Handle create/update note
    const handleSaveNote = async () => {
        if (!notesContent.trim()) {
            setNotesError("Please enter some notes before submitting");
            return;
        }

        setIsNotesLoading(true);
        setNotesError(null);
        try {
            setLoading(true);
            let response;
            const noteData = {
                customer_id: customerId,
                company_id: companyId,
                notes: notesContent,
                // user_login_id: customer?.customer_details?.user_login_id;
                user_login_id: loginUserId,
            };

            if (editingNoteId) {
                // Update existing note
                response = await PutRequest(
                    "company/updateNote",
                    { ...noteData, note_id: editingNoteId },
                    { headers },
                    extras
                );
            } else {
                // Create new note
                response = await PostRequest(
                    "company/createNote",
                    noteData,
                    false, // imgApi flag set to false
                    { headers },
                    extras
                );
            }

            if (response.data) {
                setLoading(false);
                toast.success(
                    `Note ${editingNoteId ? "updated" : "created"} successfully`
                );
                setNotesContent("");
                setEditingNoteId(null);
                fetchNotes(); // Refresh n9otes list
            } else {
                setNotesError(
                    response.message ||
                    `Failed to ${editingNoteId ? "update" : "create"} note`
                );
            }
        } catch (error) {
            setNotesError(error.message || "Error saving note");
        } finally {
            setLoading(false)
            setIsNotesLoading(false);
        }
    };

    const handleEditNote = async (noteId) => {
        setIsNotesLoading(true);
        setNotesError(null);

        try {
            setLoading(true)
            const response = await GetRequest(
                `company/getNotesById/${noteId}/${companyId}/${customerId}/${loginUserId}`,
                { headers },
                extras
            );

            if (response.data && response.data.length > 0) {
                const note = response.data[0]; // <-- yaha pe sahi note milega
                setNotesContent(note.notes); // editor me ye content jayega
                setEditingNoteId(noteId);
                setIsNotesOpen(false); // editor khol de
            } else {
                setNotesError("Failed to load note for editing");
            }
        } catch (error) {
            setNotesError(error.message || "Error loading note");
        } finally {
            setLoading(false)
            setIsNotesLoading(false);
        }
    };

    // Handle delete note
    const handleDeleteNote = async (noteId) => {
        setIsNotesLoading(true);
        setNotesError(null);
        setLoading(true)
        try {
            const response = await DeleteRequest(
                `company/deleteNotes/${companyId}/${noteId.id}/${loginUserId}/${customerId}`,
                { headers },
                extras
            );

            if (response.status === "success") {
                toast.success("Note deleted successfully");
                fetchNotes(); // Refresh notes list
                setShowDeleteModal(false);
                setLoading(false)
            } else {
                setNotesError(response.message || "Failed to delete note");
                setLoading(false)
            }
        } catch (error) {
            setNotesError(error.message || "Error deleting note");
            setLoading(false)
        } finally {
            setIsNotesLoading(false);
            setLoading(false)
        }
    };


    return (
        <div
            className="listStyleForContact"
            style={{
                minHeight: "33rem",
                height: "23rem",

                overflowX: "auto",
            }}
        >
            {isNotesLoading && !notesContent ? (
                <div className="text-center py-4">
                    Loading notes...
                </div>
            ) : (
                <>
                    {/* Editor when add/update note */}
                    {(!isNotesOpen || editingNoteId) && (
                        <>
                            <div
                                className="mb-3 p-2"
                                style={{
                                    animation:
                                        "cardEntry 1s ease-out forwards",
                                }}
                            >
                                <ReactQuill
                                    theme="snow"
                                    value={notesContent}
                                    onChange={(value) =>
                                        setNotesContent(value)
                                    }
                                    placeholder="Write your message..."
                                    style={{ minHeight: "160px" }}
                                    modules={{
                                        toolbar: [
                                            [{ header: [1, 2, false] }],
                                            [
                                                "bold",
                                                "italic",
                                                "underline",
                                                "link",
                                            ],
                                            [
                                                { list: "ordered" },
                                                { list: "bullet" },
                                            ],
                                            ["blockquote", "code-block"],
                                            ["clean"],
                                        ],
                                    }}
                                />
                            </div>

                            {notesError && (
                                <p className="text-danger mt-0 mb-0 fs-12">
                                    {notesError}
                                </p>
                            )}

                            <div className="d-flex justify-content-end gap-2 mb-2 pe-2">
                                <button
                                    className="btn btn-default-outline"
                                    style={{ fontSize: 13 }}
                                    onClick={() => {
                                        setNotesContent("");
                                        setEditingNoteId(null);
                                        setIsNotesOpen(true); // go back to list
                                        setNotesError(false)
                                    }}
                                    disabled={isNotesLoading}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-default"
                                    style={{ fontSize: 13 }}
                                    onClick={() => {
                                        handleSaveNote();
                                        // setIsNotesOpen(true); // hide editor after save
                                    }}
                                    disabled={isNotesLoading}
                                >
                                    {isNotesLoading
                                        ? "Saving..."
                                        : editingNoteId
                                            ? "Update"
                                            : "Save"}
                                </button>
                            </div>
                        </>
                    )}

                    {/* Notes List */}
                    {loading && (
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 1000,
                                borderRadius: "inherit",
                            }}
                        >
                            <div className="d-flex flex-column align-items-center">
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{ width: "3rem", height: "3rem" }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                {/* <div className="mt-2 text-primary fw-semibold">
                                        Form Submitting..
                                      </div> */}
                            </div>
                        </div>
                    )}
                    <div className="notes-list p-3 px-1">
                        <div className="d-flex px-3 align-items-center justify-content-between">
                            <p>Previous Notes : </p>

                            {/*  Add button will always show when isNotesOpen is true */}
                            {isNotesOpen && (
                                <button
                                    className="btn btn-default-outline"
                                    style={styles.buttons}
                                    onClick={() => {
                                        if (!companyNoteGrant.isCreate) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        setIsNotesOpen(false); // show editor when Add is clicked
                                        setNotesContent("");
                                        setEditingNoteId(null);
                                    }}
                                    disabled={isNotesLoading}
                                >
                                    {isNotesLoading ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon={faPlus} />{" "}
                                            Add
                                        </>
                                    )}
                                </button>
                            )}
                        </div>

                        {
                            companyNoteGrant.isView ?
                                notes.length > 0 ? (
                                    notes.map((note) => {
                                        const text =
                                            note.notes +
                                            '<span style="display:inline"></span>';

                                        const cleanHTML = text;

                                        const wordLimit = 20;
                                        const words = cleanHTML.split(" ");
                                        const isExpanded =
                                            expandedNoteId === note.id;
                                        const shouldShowButton =
                                            words.length > wordLimit;

                                        const displayedText = isExpanded
                                            ? cleanHTML
                                            : words.slice(0, wordLimit).join(" ");

                                        const inlineHtml =
                                            forceInline(displayedText);

                                        return (
                                            <div
                                                key={note.id}
                                                className="p-3 border-bottom"
                                            >
                                                <div className="d-flex justify-content-between align-items-start">
                                                    {/* Note Text */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            fontSize: 14,
                                                            color: "black",
                                                        }}
                                                    >
                                                        <FaStickyNote
                                                            size={18}
                                                            style={{
                                                                minWidth: 18,
                                                                marginRight: 10,
                                                                marginTop: 4,
                                                            }}
                                                        />
                                                        <span
                                                            style={{ display: "inline" }}
                                                        >
                                                            <span
                                                                dangerouslySetInnerHTML={{
                                                                    __html: inlineHtml,
                                                                }}
                                                                style={{ display: "inline" }}
                                                            />{" "}
                                                            {shouldShowButton && (
                                                                <span
                                                                    onClick={() =>
                                                                        setExpandedNoteId(
                                                                            isExpanded
                                                                                ? null
                                                                                : note.id
                                                                        )
                                                                    }
                                                                    style={{
                                                                        color: "blue",
                                                                        cursor: "pointer",
                                                                        display: "inline",
                                                                    }}
                                                                >
                                                                    {isExpanded
                                                                        ? "...less"
                                                                        : "...more"}
                                                                </span>
                                                            )}
                                                        </span>
                                                    </div>

                                                    {/* Dropdown */}
                                                    <Dropdown className="dropdropdownsWithoutToggle">
                                                        <Dropdown.Toggle
                                                            variant="none"
                                                            id={`dropdown - note - ${note.id}`}
                                                            style={{
                                                                border: "none",
                                                                background: "none",
                                                            }}
                                                            className="dropdownTogglesBtns ms-3 p-0"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faEllipsisVertical}
                                                                style={{ color: "black" }}
                                                            />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    if (!companyNoteGrant.isEdit) {
                                                                        toast.warning("You are not /thorized for this action!")
                                                                        return
                                                                    }
                                                                    handleEditNote(note.id)
                                                                }
                                                                }
                                                            >
                                                                Edit
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    if (!companyNoteGrant.isDelete) {
                                                                        toast.warning("You are not authorized for this action!")
                                                                        return
                                                                    }
                                                                    setNoteToDelete(note);
                                                                    setShowDeleteModal(true);
                                                                }}
                                                            >
                                                                Delete
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>

                                                {/* Footer with user + date */}
                                                <p
                                                    className="mb-0 mt-3 d-flex justify-content-between"
                                                    style={{
                                                        fontWeight: 300,
                                                        fontSize: 12,
                                                        color: "#aeaeae",
                                                    }}
                                                >
                                                    {note.added_name}
                                                    <span>
                                                        {formatDateInAlphabeticalMonth(
                                                            note.created_at
                                                        )}{" "}
                                                        | at {formatTime(note.created_at)}
                                                    </span>
                                                </p>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{ position: "absolute", left: "16%" }}
                                    >
                                        <img
                                            src={nodata}
                                            alt=""
                                            style={{ width: "15rem", marginTop: "0" }}
                                        />
                                    </div>
                                )
                                :
                                <UnauthViewModal tabName={"Notes"} />
                        }
                    </div>
                </>
            )}
            <DeleteModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={() => handleDeleteNote(noteToDelete)}
                note={noteToDelete}
                isLoading={loading}
                message="Are you want delete note?"
            />
        </div>
    )
}
const styles = {
    bottomP: {
        fontSize: 11,
    },
    bottomH4: {
        marginBottom: 2,
    },
    buttons: {
        color: "#fff",
        fontSize: "13px",
        height: "27px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "-16px",
    },
    filterbuttons: {
        fontSize: "13px",
        height: "34px",
        width: "34px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    ulStyles: {
        display: "flex",
        alignItems: "center",
        gap: "3px",
        justifyContent: "space-between",
        width: "100%",
    },
    listButtonsStyles: {
        fontSize: "13px",
        // borderBottom: '1px solid #e3e3e3',
        height: "30px",
        width: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
        gap: 3,
    },
    navButtonsStyles: {
        fontSize: "15px",
        height: "34px",
        minWidth: "34px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
    },
    iconStyles: {
        fontSize: 13,
        color: "#fff",
    },
    emptyDivs: {
        borderRight: "1px solid #E0E4F8",
        height: "35px",
        margin: "0px 2px",
    },
    DropdownItemsStyle: {
        fontSize: ".93re",
        letterSpacing: ".0386rem",
        fontWeight: 400,
        color: "#2e384d",
    },
    navLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    inActiveNavLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,



        lineHeight: 1.5,
        pointerEvents: "none",
    },
    tabContainer: {
        border: "1px solid #E0E4F8",
        borderRadius: "4px",
    },
    stickyHeader: {
        paddingBottom: "11px",
        position: "sticky",
        background: "#fff",
        top: "0px",
    },
    labels: {
        fontSize: "12px",
        color: "#B0BAC9",
        fontWeight: 400,
    },
    iconsStyles: {
        color: "#2656a8",
        border: "1px solid #e6e6e6",
        background: "#e9f1ff",
        padding: "9px",
        borderRadius: "50%",
        marginRight: "10px",
        width: "15px",
        height: "15px",
        fontSize: "13px",
    },
    values: {
        color: "#2e384d",
        fontWeight: 400,
        fontSize: ".8333rem",
        letterSpacing: '0.25px',
    },
    accordion__item: {
        borderRadius: "0px",
        borderBottom: " 1px solid #d7d7d7",
        animation: "cardEntry 1s ease-out forwards",
    },
    accordion__heading: {
        width: "100%",
    },
    accordion__panel: {
        padding: "14px 0px ",
        maxHeight: "35rem",
        overflow: "auto",
        minHeight: "35rem",
        animation: "cardEntry 1s ease-out forwards",
    },
    accordion__button: {
        display: "flex",
        alignItems: "center",
        padding: "13px 20px",
        justifyContent: "space-between",
        background: "#f4f4f4",
    },
    accordion__title: {
        marginBottom: 0,
        fontWeight: 300,
        letterSpacing: "0.0119rem",
        fontSize: "1rem",
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
        gap: "5px",
    },
    contactDetails: {
        display: "flex",
        alignItems: "center",
        gap: "13px",
        padding: "14px 16px ",
        borderBottom: "0.01rem solid #ebebeb",
    },
    roundedIcons: {
        width: "45px",
        height: "45px",
        backgroundColor: "#d5d6e8",
        color: "#2e384d",
    },
    departmentName: {
        color: "#3f97fd",
        fontSize: "13px",
        fontWeight: 400,
        marginLeft: "9px",
        marginBottom: 0,
    },
    departmentEmails: {
        color: "grey",
        fontWeight: 300,
    },
    listButtonsStyless: {
        fontSize: "13px",
        // borderBottom: '1px solid #e3e3e3',
        height: "30px",
        width: "56px",
        gap: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
        color: "#fff",
    },
};